import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { deleteBooking } from '@services/bookingService';

const CancelBookingModal = ({ isOpen, onClose, booking, setNotification }) => {
  if (!booking) return null;

  const handleConfirm = async () => {
    try {
      const response = await deleteBooking(booking.booking_id);
      setNotification({ message: response.message, type: 'success' });
      onClose(true);
    } catch (error) {
      setNotification({ message: error.response?.data?.detail || 'Error al cancelar la reserva', type: 'error' });
      onClose(false);
    }
  };

  const now = new Date();
  const startDate = new Date(booking.start_date);
  const hoursDifference = (startDate.getTime() - now.getTime()) / 3600000;
  const isUntimely = hoursDifference < 2.5;

  return (
    <Modal open={isOpen} onClose={() => onClose(false)}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
      }}>
        <Typography variant="h6" component="h2">
          Confirmar Cancelación
        </Typography>
        <Typography sx={{ mt: 2 }}>
          ¿Estás seguro de que deseas cancelar esta reserva?
        </Typography>
        {isUntimely && (
          <Typography sx={{ mt: 2, color: 'warning.main' }}>
            Atención: Cancelar con menos de 2.5 horas de antelación afecta la disponibilidad del espacio. Se aplicará un cargo mínimo que se debitará de tu billetera.
          </Typography>
        )}
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => onClose(false)} sx={{ mr: 1 }}>Cancelar</Button>
          <Button onClick={handleConfirm} variant="contained" color="error">
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CancelBookingModal;